import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("label", { for: "add-effect" }, "Add effect", -1)),
    _createElementVNode("select", {
      name: "add-effect",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleAddEffect && _ctx.handleAddEffect(...args)))
    }, [
      _cache[1] || (_cache[1] = _createElementVNode("option", {
        value: "default",
        selected: ""
      }, "-", -1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableEffects, (effect, i) => {
        return (_openBlock(), _createElementBlock("option", {
          key: i,
          value: effect.name
        }, _toDisplayString(effect.name), 9, _hoisted_1))
      }), 128))
    ], 32)
  ], 64))
}